import { Box, MediaFlex, Shimmer } from "@jewlr/storybook/core"
import React from "react"

import WizardPricingLoading from "./wizard-pricing-loading"

const WizardHeaderLoading = () => (
  <>
    <MediaFlex
      greaterThanOrEqual="tablet"
      justifyContent="space-between"
      mb="10px"
    >
      <Box>
        <Shimmer height="25px" mb="2px" width="180px" />
        <Shimmer height="25px" width="180px" />
      </Box>
      <Box>
        <WizardPricingLoading />
      </Box>
    </MediaFlex>
    <MediaFlex
      alignItems="center"
      flexDirection="column"
      lessThan="tablet"
      mb="10px"
    >
      <Shimmer height="10px" mb="10px" width="75px" />
      <Shimmer height="10px" mb="10px" width="200px" />
      <Shimmer height="10px" width="75px" />
    </MediaFlex>
  </>
)

export default WizardHeaderLoading
